export default __webpack_public_path__ + "static/media/pic4.8e063732.jpg";